import React, { useState } from 'react';
import styles from './ForthScreen.module.css';
import Button from '../components/button/Button';

const PlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

const MinusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

const faqData = [
  {
    question: "למה שאני לא אעסיק מזכירה רגילה במשרד?",
    answer: "שאלה מעולה. עם מזכירה במשרד יש לך יחסי עובד-מעביד, תנאים סוציאליים, פנסיה, ימי מחלה, חופשות, ומה קורה כשהילד שלה חולה? אתה נשאר בלי מענה. איתנו? אין את כל הכאב ראש הזה. אתה מקבל שירות מקצועי קבוע בלי להתעסק עם משכורות, תלושים והפתעות. וחוץ מזה - מזכירה רגילה עושה מה שאומרים לה, ואתה צריך לנהל אותה. אנחנו? אנחנו הדמות הניהולית. לוקחות ממך את כל הכאב ראש - גבייה, לידים, תיאום, סדר וארגון - ופשוט מטפלות. בלי שתצטרך לחשוב על זה."
  },
  {
    question: "מה קורה אם אני לא מנצל את כל השעות בחבילה החודשית?",
    answer: "השעות לא עוברות לחודש הבא - וזה דווקא דבר טוב. למה? כי זה דוחף אותך להשתמש בנו.. מתחילים לרוב מהמסלול שאתה בטוח תנצל את כל השעות ומשם מגבירים קצב בעת הצורך"
  },
  {
    question: "מה שעות הפעילות שלכן? מה אם לקוח צריך אותי בערב?",
    answer: "אנחנו פעילות 8:30-16:00, אבל בוא נהיה כנים - אם יש משהו דחוף, אנחנו מטפלות גם אחרי שעות הפעילות ומסדרות את הכל בבוקר. הלקוחות שלך לא ירגישו שיש 'חור' - הם יקבלו מענה מקצועי כאילו יש לך צוות שלם."
  },
  {
    question: "אני מפחד לשחרר שליטה על דברים בעסק שלי...",
    answer: "זה הפחד הכי נפוץ - ואני מבינה אותו לגמרי. בניתם את העסק בידיים, קשה לתת למישהו אחר לגעת. אבל הנה האמת: כל עוד אתה עושה הכל לבד, אתה תמיד תהיה התקרה של העסק שלך. אנחנו לא לוקחות ממך שליטה - אנחנו נותנות לך את הזמן לשלוט בדברים שבאמת משנים."
  },
 
  {
    question: "איך אני יודע שאתן באמת תטפלו בדברים ולא רק 'תסמנו וי'?",
    answer: "אחרי יותר מעשור בתחום ומאות עסקים שליווינו, אני יכולה להגיד לך דבר אחד - אנחנו לא מסמנות וי, אנחנו פותרות בעיות. זה מה שאני עושה מאז ומתמיד - שומעת בעיה, מיד חושבת איך לפתור אותה. התחלתי ככה בפלאפון, ניהלתי שם מוקדי שירות שלמים, והיום אני עושה את זה לעסקים כמו שלך. אתה תראה את ההבדל כבר בשבוע הראשון."
  },

  {
    question: "מה קורה בחודש הראשון? אני מחויב למשהו?",
    answer: "בחודש הראשון - לא משנה על איזו חבילה לקחת - אתה משלם רק על הזמן שצרכת בפועל. זה נותן לך לבדוק אותנו בלי סיכון, ולנו לבדוק שאנחנו באמת יכולות לעזור לך. אחרי עשור בתחום, אני יודעת שברגע שתראה איך אנחנו עובדות - לא תרצה לחזור אחורה."
  }
];

const FAQItem = ({ question, answer, isOpen, onClick, index }) => {
  return (
    <div 
      className={`${styles.faqItem} ${isOpen ? styles.open : ''}`}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <button 
        className={styles.faqQuestion}
        onClick={onClick}
        aria-expanded={isOpen}
      >
        <span className={styles.questionText}>{question}</span>
        <span className={styles.icon}>
          {isOpen ? <MinusIcon /> : <PlusIcon />}
        </span>
      </button>
      <div className={`${styles.faqAnswer} ${isOpen ? styles.answerOpen : ''}`}>
        <p className={styles.answerText}>{answer}</p>
      </div>
    </div>
  );
};

export const FAQSection = () => {
  const [openIndices, setOpenIndices] = useState([]);

  const handleClick = (index) => {
    setOpenIndices(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index) 
        : [...prev, index]
    );
  };

  return (
    <section className={styles.section}>
      <div className={styles.bgPattern}></div>
      
      <div className={styles.container}>
        
        <div className={styles.headerWrapper}>
       
          <h2 className={styles.title}>
            כל מה שרצית לדעת
            <br />
            <span className={styles.greenText}>נמצא כאן</span>
          </h2>
          <p className={styles.subtitle}>
   ריכזנו את השאלות שכנראה עלו לך לראש במהלך הדף, לחץ על כך שאלה והתשובה תיפתח.
          </p>
        </div>

        <div className={styles.faqWrapper}>
          {faqData.map((item, index) => (
            <FAQItem
              key={index}
              index={index}
              question={item.question}
              answer={item.answer}
              isOpen={openIndices.includes(index)}
              onClick={() => handleClick(index)}
            />
          ))}
        </div>

     

      </div>
      <Button text="יש לי עוד שאלה"/>
    </section>
  );
};